import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useFavoris } from '../context/FavorisContext';

const BottomNavbar = () => {
  const location = useLocation();
  const { isAuthenticated, user } = useAuth();
  const { totalFavoris } = useFavoris();

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  const navItems = [
    {
      path: '/',
      icon: 'fas fa-home',
      label: 'Accueil',
      active: isActive('/')
    },
    {
      path: '/produits',
      icon: 'fas fa-shopping-bag',
      label: 'Produits',
      active: isActive('/produits')
    },
    {
      path: '/artisans',
      icon: 'fas fa-users',
      label: 'Artisans',
      active: isActive('/artisans')
    },
    ...(isAuthenticated
      ? [
          {
            path: '/favoris',
            icon: 'fas fa-heart',
            label: 'Favoris',
            active: isActive('/favoris'),
            badge: totalFavoris > 0 ? totalFavoris : null
          }
        ]
      : []),
    ...(isAuthenticated && user?.role === 'admin'
      ? [
          {
            path: '/admin',
            icon: 'fas fa-tools',
            label: 'Admin',
            active: isActive('/admin')
          }
        ]
      : []),
    {
      path: isAuthenticated ? '/profile' : '/login',
      icon: isAuthenticated ? 'fas fa-user' : 'fas fa-sign-in-alt',
      label: isAuthenticated ? 'Profil' : 'Connexion',
      active: isActive(isAuthenticated ? '/profile' : '/login')
    }
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white dark:bg-gray-800 border-t-2 border-primary-200 dark:border-gray-700 shadow-lg z-50 md:hidden">
      <div className="flex items-center justify-around h-16 px-2">
        {navItems.map((item, index) => (
          <Link
            key={index}
            to={item.path}
            className={`flex flex-col items-center justify-center flex-1 h-full relative transition-all duration-200 ${
              item.active
                ? 'text-primary-800 dark:text-primary-400'
                : 'text-gray-500 dark:text-gray-400'
            }`}
          >
            <div className="relative">
              <i className={`${item.icon} text-xl mb-1 ${item.active ? 'scale-110' : ''} transition-transform duration-200`}></i>
              {item.badge && (
                <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
                  {item.badge > 9 ? '9+' : item.badge}
                </span>
              )}
            </div>
            <span className={`text-xs font-medium ${item.active ? 'font-semibold' : ''}`}>
              {item.label}
            </span>
            {item.active && (
              <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-12 h-1 bg-primary-800 dark:bg-primary-400 rounded-b-full"></div>
            )}
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default BottomNavbar;

